export default __webpack_public_path__ + "static/media/Artboard2.615bb9be.319fb0d6.png";